var TelemetryExceptionName = /* @__PURE__ */ ((TelemetryExceptionName2) => {
  TelemetryExceptionName2["Core_MSALAuthContext_trackError"] = "Core_MSALAuthContext_trackError";
  return TelemetryExceptionName2;
})(TelemetryExceptionName || {});
export {
  TelemetryExceptionName
};
//# sourceMappingURL=TelemetryExceptionName.js.map
